export const aiExamples = [
  {
    label: "Draw a cat",
    summary: "Ask AI for a sketch and a sharing link.",
    prompt: "Create a new Excalidraw-MS drawing of a cat and send me its sharing link.",
    image: "/ai-cat.svg",
    alt: "Illustrative cat drawing",
  },
  {
    label: "Repo architecture",
    summary: "Create an architecture diagram for your project.",
    prompt:
      "Create a new Excalidraw-MS drawing showing this project's architecture, including its main components and how they connect. Send me its sharing link.",
    image: "/ai-architecture.svg",
    alt: "Illustrative architecture diagram",
  },
] as const;
